module.exports = __webpack_public_path__ + "static/media/CP09_STRAIGHT_STREAM.84c79f8e.png";